import { composeIO } from 'react-compose-io'
import { cabecalhoTabelaContabilizacaoIO } from './CabecalhoTabelaContabilizacao.IO'
import { CabecalhoTabelaContabilizacaoView } from './CabecalhoTabelaContabilizacao.View'

export const CabecalhoTabelaContabilizacao = composeIO(CabecalhoTabelaContabilizacaoView, cabecalhoTabelaContabilizacaoIO)
